var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hidden-button addParam",staticStyle:{"background-color":"white"}},[_c('i',{class:[_vm.buttonClasses[this.styleType]]}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }